// create user reducer
import {
    GET_MOBILE_FINNANCE_UPDATE_REQUEST,
    GET_ALL_MOBILE_FINNANCE_REQUEST,
    GET_ALL_MOBILE_FINNANCE_SUCCESS,
    GET_MOBILE_FINNANCE_SUCCESS,
    GET_MOBILE_FINNANCE_FAIL,
    GET_MOBILE_FINNANCE_REQUEST,
} from "../types/mobileFinnance";

const initialState = {
    mobileFinnance: null,
    singleMobileFinnance: null,
    loading: false,
    sucess: false,
    error: null,
};
const mobileFinnance = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_MOBILE_FINNANCE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_ALL_MOBILE_FINNANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                sucess: true,
                mobileFinnance: action.payload,
                error: null,
            };
        case GET_MOBILE_FINNANCE_UPDATE_REQUEST:
            return {
                ...state,
                loading: false,
                // mofile: action.payload,
            };
        case GET_MOBILE_FINNANCE_REQUEST:
            return {
                ...state,
                loading: true,
                sucess: false
            };
        case GET_MOBILE_FINNANCE_SUCCESS:
            return {
                ...state,
                loading: false,
                sucess: true,
                error: null,
                singleMobileFinnance: action.payload,
            };
        case GET_MOBILE_FINNANCE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                sucess: false,

            };
        default:
            return state;
    }
};

export default mobileFinnance;